import React, { useEffect } from 'react'
import { Scissors, ShoppingBag, RefreshCw } from 'lucide-react'
import { AgendaInteligenteController } from '../../../../services/controllers/agendaInteligente'
import { useAgendaInteligente } from '../../../../store/agendaInteligente/useAgendaInteligente'
import { formatCpf, validadeCpf } from '../../../../services/functions'
import {
  ExpandedWrap, HistSection, HistTitle, HistList, HistItem, HistDate
} from '../styles'

export function ExpandedRow({ appointment }) {
  const C   = AgendaInteligenteController()
  const id  = appointment.appointmentId
  const cache = useAgendaInteligente(st => st.data.historyCache[id])

  useEffect(() => {
    C.loadHistory(appointment)
  }, [id]) // eslint-disable-line

  const servicos  = cache?.servicos || []
  const compras = cache?.compras || []

  const servicosAgendados = appointment.servicosCompletos || appointment.servicos || []
  const loading = cache === null
  const cpf = validadeCpf(appointment.cliente.cpf)
    ? formatCpf(appointment.cliente.cpf)
    : null

  return (
    <ExpandedWrap>
      {/* Linha de info: Serviços agendados, pet info */}
      {(servicosAgendados.length > 0 || appointment.pet.raca) && (
        <div style={{ gridColumn: '1 / -1', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          {servicosAgendados.length > 0 && (
            <>
              <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#d97706' }}>Serviços agendados:</span>
              {servicosAgendados.map((s, i) => (
                <span key={i} style={{ fontSize: 12, fontWeight: 600, background: '#fef3c7', color: '#92400e', border: '1px solid #fcd34d', borderRadius: 4, padding: '2px 8px' }}>{s}</span>
              ))}
            </>
          )}
        </div>
      )}

      {/* Histórico de serviços */}
      <HistSection>
        <HistTitle>
          <Scissors size={11} /> Histórico de serviços
          {[appointment.pet.raca, appointment.pet.porte, appointment.pet.pelagem].filter(Boolean).map((v, i) => (
            <span key={i}><span style={{ opacity: 0.4, margin: '0 2px' }}>·</span>{v}</span>
          ))}
        </HistTitle>
        {loading
          ? <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#9ca3af' }}><RefreshCw size={12} style={{ animation: 'spin 1s linear infinite' }} />Carregando…</div>
          : <HistList>
              {servicos.length === 0
                ? <HistItem>Sem histórico de serviços.</HistItem>
                : servicos.map((s, i) => (
                    <HistItem key={i}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.title}</span>
                      <HistDate empty={!s.lastPurshace || s.lastPurshace === 'Nunca comprou'}>
                        {s.lastPurshace || 'Nunca realizou'}
                      </HistDate>
                    </HistItem>
                  ))
              }
            </HistList>
        }
      </HistSection>

      {/* Histórico de compras */}
      <HistSection>
        <HistTitle>
          <ShoppingBag size={11} /> Compras
          {cpf && (
            <><span style={{ opacity: 0.4, margin: '0 2px' }}>·</span>
            <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>CPF: {cpf}</span></>
          )}
          {!cpf && (
            <><span style={{ opacity: 0.4, margin: '0 2px' }}>·</span>
            <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>CPF: Não informado</span></>
          )}
        </HistTitle>
        {loading
          ? <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#9ca3af' }}><RefreshCw size={12} style={{ animation: 'spin 1s linear infinite' }} />Carregando…</div>
          : <HistList>
              {compras.length === 0
                ? <HistItem>Sem histórico de compras.</HistItem>
                : compras.map((p, i) => (
                    <HistItem key={i}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 500 }}>{p.lastItem || p.title}</span>
                      <HistDate empty={!p.lastPurshace || p.lastPurshace === 'Nunca comprou'}>
                        {p.lastPurshace || 'Nunca comprou'}
                      </HistDate>
                    </HistItem>
                  ))
              }
            </HistList>
        }
      </HistSection>
    </ExpandedWrap>
  )
}
